const CloseMessage = () => {
    return (
        <section id="close-message">
            <div className="container-fluid pt-4 pb-4 text-center">
                <div className="row align-items-center justify-content-center my-4">
                    <div className="col-md-10 col-11 text-center">
                        <h2><mark className="gg-mark-yellow fw-bold text-uppercase">If you close this page it will not appear again</mark></h2>
                    </div>
                    <div className="row align-items-center justify-content-center mt-4">
                    <div className="col-xl-6 col-11 text-center">
                        <h3 className="fw-light">Because our supply is limited, we can extend this invitation to only a select group of shoppers today. Once you leave this page, the offer disappears.</h3>
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
};

export default CloseMessage;